import { computed, Injectable, signal } from '@angular/core';
import { Notification } from '../interfaces/notifications';
import { UserAuthentication } from '../interfaces/user-authentication';
import { HTTPService } from './http.service';
import { catchError, of, Subject, Subscription, takeUntil } from 'rxjs';
import { ObjectUtil } from '../system-utils/utils/ObjectUtil';


@Injectable({
  providedIn: 'root'
})
export class NotificationsService {


  constructor(private http:HTTPService) { 
      this.userInformation = JSON.parse(localStorage.getItem("user"));

  }

  data;
  codecompany;
  userInformation:UserAuthentication;
  sub:Subscription;
  private destroy$ = new Subject<void>();

  private readonly _items = signal<Notification[]>([]);
  readonly items = this._items.asReadonly();
  readonly unreadCount = computed(() => this._items().filter(n => n.STATUS?.toLowerCase()=="new").length);

  getNotifications (){

      let ob = {
          iduser: this.userInformation.iduser,
          codecompany: this.userInformation.codecompany
      }

      return this.http.post(ob,"NotificationsServices/notifications",false,true,false,false);
  }

  ngOnDestroy(){
    this.destroy$.next();
    this.destroy$.complete();
    if ( this.sub!= null){
      this.sub.unsubscribe();
    }
  }


  fetchNotifications(): Promise<void> {
    return new Promise((resolve) => {
      this.sub = this.getNotifications()
        .pipe(
          takeUntil(this.destroy$),
          catchError(() => of([]))
        )
        .subscribe((x:any[]) => {
          
          if ( !x ){
            this.setItems([]);
            resolve();
            return;
          }

          if ( !(x instanceof Array)){
            this.setItems([]);
            resolve();
            return;
          }
          const notifications = (x as any[]).map(n => ({
            ...n,
            RECCREATEDON: new Date(Date.parse(n.RECCREATEDON.replace(" ", "T")))
          })) as Notification[];

          const current = this._items();

          // filtra apenas os novos
          const newOnes = notifications.filter(n =>
            !current.some(c => c.IDALERT === n.IDALERT)
          );

          // ordena por data (mais recentes primeiro)
          const merged = [...newOnes, ...current].sort((a, b) =>
            b.RECCREATEDON.getTime() - a.RECCREATEDON.getTime()
          );
          this.setItems(merged);
          resolve();
        });
    });
  }


  setItems(list: Notification[]): void {
        this._items.set(list);
  }


  markAsRead(id: Notification['IDALERT']): void {
        if (this._items().find(n => n.IDALERT === id)?.STATUS?.toLowerCase()!="new") {
            return;
        }
        this.patch(id, { STATUS: "read" }); // otimista
        this.read(id).subscribe({ error: () => this.patch(id, { STATUS: "new" }) });
    }
  read(id: number) {
     let ob = {
        IDALERT:id
     }  
     return this.http.post(ob,"NotificationsServices/read",false,true,false,false);
  }
 
  markAllAsRead(): void {
        const prev = this._items();
        if (!prev.some(n => n.STATUS.toLowerCase()=="new")) {
            return;
        }
        this._items.set(prev.map(n => ({ ...n, STATUS: "read" })));
        this.readAll(prev).subscribe({ error: () => this._items.set(prev) });
  }

  readAll(prev: Notification[]) {
     const toread = prev.filter(n=>n.STATUS.toLowerCase()=="new")
     return this.http.post(toread,"NotificationsServices/readall",false,true,false,false);
  }
 
  private patch(id: Notification['IDALERT'], partial: Partial<Notification>): void {
      this._items.update(list =>
          list.map(n => (n.IDALERT === id ? { ...n, ...partial } : n)),
      );
  }
}
